import React from 'react';

import SvgContainer from '../SvgContainer';

const PointerRight = () => {
    return (
        <SvgContainer>
            <path d="M10.9007 12.553C10.6155 12.8076 10.1845 12.8076 9.89934 12.553C9.56483 12.2543 9.56455 11.7311 9.89873 11.4321L12.936 8.71429H0.714286C0.319797 8.71429 0 8.39449 0 8C0 7.60551 0.319797 7.28571 0.714285 7.28571H12.936L9.8961 4.57152C9.55958 4.27105 9.5605 3.74428 9.89808 3.44499C10.1843 3.19127 10.6151 3.19203 10.9004 3.44675L15.1645 7.25406C15.6099 7.65166 15.6099 8.34834 15.1645 8.74594L10.9007 12.553Z" />
        </SvgContainer>
    );
};

export default PointerRight;
